import React, { useMemo, useState } from 'react'
import BillingSummaryRow from 'pages/Billing/components/BillingSummaryRow'
import TransactionCampaignPill from './components/TransactionCampaignPill'
import TransactionFilterBar from './components/TransactionFilterBar'
import TransactionStats from './components/TransactionStats'
import TransactionSummaryPanel from './components/TransactionSummaryPanel'
import AccountLegendPanel from './components/AccountLegendPanel'
import TransactionTable from './components/TransactionTable'
import TransactionDetailDrawer from './components/TransactionDetailDrawer'
import { LEDGER_STATS, TRANSACTION_SUMMARY, ACCOUNT_LEGEND, CAMPAIGN_OPTIONS, LEDGER_ROWS, FILTER_OPTIONS } from './mock/ledger'

// The Credit/Prize Account ledger (stats, transaction summary, legend, and the
// per-transaction rows in the table below) has no backing endpoint yet — this
// page ships against `mock/ledger.js`, matching the Figma design 1:1, ready
// to be wired to a real ledger endpoint once the API contract is confirmed.
export default function Transaction() {
  const [activeCampaign, setActiveCampaign] = useState(CAMPAIGN_OPTIONS[0])
  const [year, setYear] = useState(FILTER_OPTIONS.years[0])
  const [account, setAccount] = useState(FILTER_OPTIONS.accounts[0])
  const [type, setType] = useState(FILTER_OPTIONS.types[0])
  const [status, setStatus] = useState(FILTER_OPTIONS.statuses[0])
  const [selectedTransaction, setSelectedTransaction] = useState(null)

  const rows = useMemo(() => LEDGER_ROWS.filter((row) => {
    if (account !== FILTER_OPTIONS.accounts[0] && row.account !== account) return false
    if (type !== FILTER_OPTIONS.types[0] && row.type !== type) return false
    if (status !== FILTER_OPTIONS.statuses[0] && row.status !== status) return false
    return true
  }), [account, type, status])

  const csvData = useMemo(() => {
    const head = ['Date & Time', 'Account', 'Reference ID', 'Description', 'Type', 'Amount', 'Balance After', 'Balance', 'Status']
    const body = rows.map((row) => [row.dateTime, row.account, row.reference, row.description, row.type, row.amount, row.balanceAfter, row.balance, row.status])
    return [head, ...body]
  }, [rows])

  return (
    <section className="w-full max-w-6xl mx-auto pb-10 flex flex-col gap-6">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <h1 className="text-2xl font-semibold text-dark-blue">Transactions</h1>
        <TransactionCampaignPill campaigns={CAMPAIGN_OPTIONS} active={activeCampaign} onSelect={setActiveCampaign} />
      </div>

      <TransactionFilterBar
        year={year}
        onChangeYear={setYear}
        account={account}
        onChangeAccount={setAccount}
        type={type}
        onChangeType={setType}
        status={status}
        onChangeStatus={setStatus}
        csvData={csvData}
      />

      <TransactionStats stats={LEDGER_STATS} />

      <div className="flex flex-col md:flex-row gap-6">
        <TransactionSummaryPanel summary={TRANSACTION_SUMMARY} />
        <AccountLegendPanel items={ACCOUNT_LEGEND} />
      </div>

      <BillingSummaryRow />

      <TransactionTable title="ALL TRANSACTIONS" rows={rows} onRowClick={setSelectedTransaction} />

      {selectedTransaction && <TransactionDetailDrawer transaction={selectedTransaction} onClose={() => setSelectedTransaction(null)} />}
    </section>
  )
}
